/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import OktaAuth from "@okta/okta-auth-js";

export const oktaConfig = {
    issuer: `https://signin.kering.com/oauth2/default`,
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    redirectUri: window.location.hostname === 'changemakerschallenge.gucci.com' ? 'https://changemakerschallenge.gucci.com/login/callback/' :
        (window.location.hostname === 'changemakerschallenge.gucci.cn' ? 'https://changemakerschallenge.gucci.cn/login/callback/' :
            (window.location.hostname === 'changemakerschallenge-dev.gucci.com' ? 'https://changemakerschallenge-dev.gucci.com/login/callback/' :
                'http://localhost:3000/login/callback/')),
    postRedirectUri: window.location.hostname === 'changemakerschallenge.gucci.com' ? 'https://changemakerschallenge.gucci.com/login/callback/' :
        (window.location.hostname === 'changemakerschallenge.gucci.cn' ? 'https://changemakerschallenge.gucci.cn/login/callback/' :
            (window.location.hostname === 'changemakerschallenge-dev.gucci.com' ? 'https://changemakerschallenge-dev.gucci.com/login/callback/' :
                'http://localhost:3000/login/callback/')),
    postLogoutRedirectUri: window.location.hostname === 'changemakerschallenge.gucci.com' ? 'https://changemakerschallenge.gucci.com/logout/callback/' :
        (window.location.hostname === 'changemakerschallenge.gucci.cn' ? 'https://changemakerschallenge.gucci.cn/logout/callback/' :
            (window.location.hostname === 'changemakerschallenge-dev.gucci.com' ? 'https://changemakerschallenge-dev.gucci.com/login/callback/' :
                'http://localhost:3000/logout/callback/')),

    //redirectUri: window.location.hostname === 'localhost' ? 'http://localhost:3000/login/callback/' : `https://${window.location.hostname}/login/callback/`,
    //postRedirectUri: window.location.hostname === 'localhost' ? 'http://localhost:3000/login/callback/' : `https://${window.location.hostname}/login/callback/`,
    //postLogoutRedirectUri: window.location.hostname === 'localhost' ? 'http://localhost:3000/logout/callback/' : `https://${window.location.hostname}/logout/callback/`,
    scopes: ["openid", "profile", "email", "offline_access"],
    pkce: true,
    tokenManager: {
        autoRenew: true
    },

    //storageManager: { token: { storageTypes: ['localStorage', 'cookie'] } }

};

export const oktaAuth = new OktaAuth(oktaConfig);

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */



/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "Enter_the_Graph_Endpoint_Herev1.0/me"
};


